<template>
	<div class="category">
		<p
			:class="['category__line']"
			v-for="(target, idx) in getTargetCategories"
			:key="idx"
		>
			<label :class="['category__selector', { 'big-size': bigSize }]">
				<select
					v-model="target.idFirstCategory"
					@change="setFirstCategory($event, idx)"
					:disabled="disabled"
				>
					<option :value="null">1차 카테고리</option>
					<option
						v-for="(category, index) in firstCategories"
						:key="index"
						:value="category.idFirstCategory"
					>
						{{ category.firstCategoryText }}
					</option>
				</select>
			</label>
			<label :class="['category__selector', { 'big-size': bigSize }]">
				<select
					v-model="target.idSecondCategory"
					@change="setSecondCategory($event, idx)"
					:disabled="disabled"
				>
					<option :value="null">2차 카테고리 전체</option>
					<option
						v-for="(category, index) in getSecondCategories(idx)"
						:key="index"
						:value="category.idSecondCategory"
					>
						{{ category.secondCategoryText }}
					</option>
				</select>
			</label>
			<label
				:class="['category__selector', { 'big-size': bigSize }]"
				v-if="categoryDepth === 'third'"
			>
				<select
					v-model="target.idThirdCategory"
					@change="setThirdCategory($event, idx)"
					:disabled="
						disabled ||
						!getHasThirdCategories(idx) ||
						target.idSecondCategory === null
					"
				>
					<option :value="null">3차 카테고리 전체</option>
					<option
						v-for="(category, index) in getThirdCategories(idx)"
						:key="index"
						:value="category.idThirdCategory"
					>
						{{ category.thirdCategoryText }}
					</option>
				</select>
			</label>

			<button
				v-if="getTargetCategories.length > 1 && !disabled"
				@click="removeTarget(idx)"
				type="button"
				:class="['category__remove', { 'big-size': bigSize }]"
			>
				<i class="fa fas fa-minus" />
			</button>
		</p>

		<div class="category__button-wrapper">
			<button
				v-if="getTargetCategories.length < categoryLimit && !disabled"
				@click="addTarget"
				type="button"
				class="category__add"
			>
				<i class="fa fas fa-plus" />
			</button>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash';

	export default {
		name: 'CategorySelector',
		props: {
			disabled: {
				type: Boolean,
				default: false,
			},
			categoryDepth: {
				type: String,
				default: 'third',
			},
			bigSize: {
				type: Boolean,
				default: false,
			},
			categoryLimit: {
				type: Number,
				default: 4,
			},
		},
		data() {
			return {
				targetCategories: [
					{
						idEventCategory: null,
						idFirstCategory: null,
						idSecondCategory: null,
						idThirdCategory: null,
					},
				],
				firstCategories: [],
				secondCategories: [],
				thirdCategories: [],
				hasThirdCategory: [false],
			};
		},
		mounted() {
			this.$store.commit('toggleSpinner', true);
			this.$axiosAdmin2
				.get('/api/categories/level/1/simple')
				.then(({ data }) => {
					this.firstCategories = data.data.filter(
						category => category.isDisplay
					);
					this.$store.commit('toggleSpinner', false);

					this.emitCategories();
				});
		},
		computed: {
			getTargetCategories() {
				return this.targetCategories;
			},
			getSecondCategories() {
				return index => {
					return this.secondCategories[index];
				};
			},
			getThirdCategories() {
				return index => {
					return this.thirdCategories[index];
				};
			},
			getHasThirdCategories() {
				return index => {
					return this.hasThirdCategory[index];
				};
			},
		},
		methods: {
			getApiUrl(step, parentId) {
				return `/api/categories/level/${step}/simple?idParentCategory=${parentId}`;
			},
			getValue(value) {
				return typeof value === 'undefined' || value === null
					? null
					: String(value);
			},
			setTargetCategory(index, first, second, third) {
				if (typeof first !== 'undefined') {
					this.targetCategories[index].idFirstCategory = first;
				}

				if (typeof second !== 'undefined') {
					this.targetCategories[index].idSecondCategory = second;
				}

				if (typeof third !== 'undefined') {
					this.targetCategories[index].idThirdCategory = third;
				}
			},
			setList(list) {
				if (list.length > 0) {
					this.targetCategories = [];
					this.hasThirdCategory = [];
					this.$store.commit('toggleSpinner', true);
					const orderedList = _.orderBy(list, [
						'idEventCategory',
						'desc',
					]);

					_.each(orderedList, async (category, index) => {
						this.targetCategories.push({});
						this.hasThirdCategory.push(false);
						this.secondCategories.push([]);
						this.thirdCategories.push([]);

						try {
							const secondCategory = await this.$axiosAdmin2.get(
								this.getApiUrl(2, category.idFirstCategory)
							);
							this.secondCategories.splice(
								index,
								1,
								secondCategory.data.data
							);

							if (category.idSecondCategory) {
								const thirdCategory =
									await this.$axiosAdmin2.get(
										this.getApiUrl(
											3,
											category.idSecondCategory
										)
									);
								this.thirdCategories.splice(
									index,
									1,
									thirdCategory.data.data
								);
								this.hasThirdCategory.splice(
									index,
									1,
									thirdCategory.data.data.length > 0
								);
							}

							this.targetCategories.splice(index, 1, {
								idEventCategory: this.getValue(
									category.idEventCategory
								),
								idFirstCategory: this.getValue(
									category.idFirstCategory
								),
								idSecondCategory: this.getValue(
									category.idSecondCategory
								),
								idThirdCategory: this.getValue(
									category.idThirdCategory
								),
							});
						} catch ({ response }) {
							console.error(response);

							if (
								confirm(
									'카테고리 목록을 불러오는데 실패 했습니다.\n확인을 눌러 다시 시도합니다.\n문제가 지속되면 개발팀에 문의해 주시기 바랍니다'
								)
							) {
								this.setList(list);
							} else {
								alert(
									'카테고리 목록을 불러오지 못했습니다.\n카테고리 관련 작업을 수행할 수 없습니다.'
								);
								return false;
							}
						}
					});

					this.$store.commit('toggleSpinner', false);
					this.emitCategories();
				}
			},
			addTarget() {
				this.targetCategories.push({
					idEventCategory: null,
					idFirstCategory: null,
					idSecondCategory: null,
					idThirdCategory: null,
				});
				this.hasThirdCategory.push(false);

				this.emitCategories();
			},
			removeTarget(index) {
				this.thirdCategories.splice(index, 1);
				this.secondCategories.splice(index, 1);
				this.targetCategories.splice(index, 1);
				this.hasThirdCategory.splice(index, 1);

				this.emitCategories();
			},
			getCategoryData(step, parentId, target, index) {
				this.$store.commit('toggleSpinner', true);

				return this.$axiosAdmin2
					.get(this.getApiUrl(step, parentId))
					.then(({ data }) => {
						target.splice(
							index,
							1,
							data.data.filter(category => category.isDisplay)
						);
						this.$store.commit('toggleSpinner', false);
					})
					.catch(({ response }) => {
						console.error(response);
						this.$store.commit('toggleSpinner', false);

						if (
							confirm(
								'카테고리 목록을 불러오는데 실패 했습니다.\n확인을 눌러 다시 시도합니다.\n문제가 지속되면 개발팀에 문의해 주시기 바랍니다'
							)
						) {
							this.getCategoryData(step, parentId, target, index);
						} else {
							alert(
								'카테고리 목록을 불러오지 못했습니다.\n카테고리 관련 작업을 수행할 수 없습니다.'
							);
							return false;
						}
					});
			},
			setFirstCategory(event, index) {
				if (!!event.target.value) {
					this.getCategoryData(
						2,
						event.target.value,
						this.secondCategories,
						index
					);
				} else {
					this.secondCategories.splice(index, 1, []);
				}

				this.targetCategories.splice(index, 1, {
					idFirstCategory: event.target.value || null,
					idSecondCategory: null,
					idThirdCategory: null,
				});

				this.setTargetCategory(
					index,
					event.target.value || null,
					null,
					null
				);
				this.hasThirdCategory[index] = false;
				this.emitCategories();
			},
			async setSecondCategory(event, index) {
				if (event.target.value) {
					await this.getCategoryData(
						3,
						event.target.value,
						this.thirdCategories,
						index
					);
					this.hasThirdCategory[index] =
						this.thirdCategories[index].length > 0;

					if (!this.hasThirdCategory[index]) {
						const targetCategories = _.cloneDeep(
							this.targetCategories
						);
						const exceptEmptyCategory = [];

						targetCategories[index].idSecondCategory =
							event.target.value;

						_.each(targetCategories, category => {
							category.idEventCategory = null;
						});

						_.each(targetCategories, category => {
							if (
								category.idFirstCategory !== null &&
								category.idSecondCategory !== null
							) {
								exceptEmptyCategory.push(category);
							}
						});

						if (
							exceptEmptyCategory.length !==
							_.uniqWith(exceptEmptyCategory, _.isEqual).length
						) {
							alert('동일한 카테고리가 선택되었습니다');
							this.setTargetCategory(
								index,
								undefined,
								null,
								null
							);
							this.targetCategories[index].idSecondCategory =
								null;
							return false;
						}
					}
				} else {
					this.thirdCategories.splice(index, 1, []);
				}

				this.setTargetCategory(
					index,
					undefined,
					event.target.value || null,
					null
				);
				this.emitCategories();
			},
			setThirdCategory(event, index) {
				if (event.target.value) {
					const targetCategories = _.cloneDeep(this.targetCategories);
					const exceptEmptyCategory = [];

					targetCategories[index].idThirdCategory =
						event.target.value;

					_.each(targetCategories, category => {
						category.idEventCategory = null;
					});

					_.each(targetCategories, category => {
						if (
							category.idFirstCategory !== null &&
							category.idSecondCategory !== null &&
							category.idThirdCategory !== null
						) {
							exceptEmptyCategory.push(category);
						}
					});

					if (
						exceptEmptyCategory.length !==
						_.uniqWith(exceptEmptyCategory, _.isEqual).length
					) {
						alert('동일한 카테고리가 선택되었습니다');
						this.setTargetCategory(
							index,
							undefined,
							undefined,
							null
						);
						this.targetCategories[index].idThirdCategory = null;
					} else {
						this.setTargetCategory(
							index,
							undefined,
							undefined,
							event.target.value
						);
					}
				} else {
					this.setTargetCategory(index, undefined, undefined, null);
				}

				this.emitCategories();
			},
			emitCategories() {
				this.$emit('change', this.targetCategories);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.category__line {
		margin-top: 24px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.category__selector {
		margin-right: 1em;
		&.big-size {
			border: 1px solid #e1e0e0;
			select {
				width: 320px;
				height: 38px;
			}
		}
	}

	.category__button-wrapper {
		text-align: center;
		padding: 1em 0 0 0;
	}

	.category__add {
		background: $btn-blue;
		width: 1.6em;
		height: 1.6em;
		border-radius: 50%;
		color: #fff;
	}

	.category__remove {
		@extend .category__add;
		background: #ff3860;
		font-size: 0.75rem;
		&.big-size {
			width: 1.8em;
			height: 1.8em;
		}
	}
</style>
